import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import style from "./Editor.module.css";
import FileTree from "./FileTree";
import SyntaxHighlightStyle from "./SyntaxHighlightStyle";

@observer
class Editor extends React.Component {
  getEmptyMessage() {
    if (this.props.store.selectedFile) {
      return null;
    }
    const hasFiles = this.props.store.files.length > 0;
    if (hasFiles) {
      return `Open a file by clicking in the file tree to the left.`;
    }
    return `In the next step, project files will appear here.`;
  }

  renderEmptyMessage() {
    const message = this.getEmptyMessage();
    if (!message) {
      return null;
    }
    return <div className={style.emptyMessage}>{message}</div>;
  }

  renderContent() {
    if (!this.props.store.selectedFile) {
      return null;
    }
    return <SyntaxHighlightStyle html={this.props.store.selectedFile.html} />;
  }

  render() {
    return (
      <div className={style.editor}>
        <div className={style.tree}>
          <FileTree store={this.props.store} />
        </div>
        {this.renderContent()}
        {this.renderEmptyMessage()}
      </div>
    );
  }
}
Editor.propTypes = {
  store: PropTypes.object.isRequired
};
export default Editor;



// WEBPACK FOOTER //
// ./src/byos/component/Editor.js